import { lazy } from "react";
const BillResult = lazy(() => import("app/pages/cb/billDetail/BillResult"));
const ContractListBase = lazy(() => import("app/pages/cb/contractList/ContractListBase"));

export const cbRouter: any = [
  { path: "/bill/result", element: <BillResult /> },
  { path: '/ot/contracts', element: <ContractListBase /> },
];
